module.exports={
    shop: {
        store:'门店',
        stores:{
        	findPro:'查找门店',
        	allPro:'所有门店',
            info:'门店信息',
            uuid:'编号',
            address:'地址'
        },
        menus:[
            {
                name:'overview',
                key:'overview',
                text:'概览'
            },{
                name:'products',
                key:'products',
                text:'商品'
            },{
                name:'label',
                key:'label',
                text:'标签'
            },{
                name:'gateway',
                key:'gateway',
                text:'网关'
            },{
                name:'record',
                key:'record',
                text:'记录'
            },{
                name:'shopsTemplates',
                key:'shopsTemplates',
                text:'模板'
            },{
                name:'import',
                key:'import',
                text:'导入'
            },{
                name:'settings',
                key:'settings',
                text:'设置'
            }
        ],
        overview:'概览',
        products:'商品',
        label:'标签',
        gateway:'网关',
        record:'记录',
        authorization:'授权',
        shopsTemplates:'模板',
        import:'导入',
        settings:'设置',
        submiting:'提交中...',
        storeMember:{
        	addMember:'添加门店成员',
        	members:'门店成员'
        },
        warning:{
            title:'预警消息',
            selected:{
                brushFailed:'刷图失败',
                upgradeFailed:'升级失败',
                bindFailed:'绑定失败'
            },
            bandTotal: '绑定总数：',
            bandFailed: '绑定失败数：',
            reUpdate:'重新刷图',
            reUgrade:'升级',
            failed:'查询预警信息失败',
            noData:'暂无数据',
            esl:'标签 ',
            rebrushSuccess:'重刷指令发送成功',
            rebrushFailed:'重刷指令发送失败',
            reupgradeSuccess:'升级指令发送成功，标签固件升级中，请保持网关在线...',
            reupgradeFailed:'升级指令发送失败',

            batchRebrushFailed:'批量重刷指令发送失败',
            batchReupgradeFailed:'批量升级指令发送失败',

            noCheck:'请勾选要重刷的标签',
            noBind:'标签没有绑定网关',
            updated:'此标签已更新',
            noUpgradePackage:'升级包已删除或不存在',
            versionError: '升级包版本错误',
            labelError: '标签异常',

            batchRebrushNoBind:'重刷指令发送失败，标签没有绑定网关',
            batchRebrushUpdated:'重刷指令发送失败，此标签已更新',

            batchReupgradeNoBind:'升级指令发送失败，标签没有绑定网关或升级包不存在',
            batchReupgradeUpdated:'升级指令发送失败，不存在此设备'

        },
        progress:{
            brush:'刷图',
            upgrade:'固件升级',
            bind:'绑定',
            brushTotal:'刷图总数：',
            brushSuccess:'刷图成功数：',
            upgradeTotal:'固件升级总数：',
            upgradeSuccess:'固件升级成功数：',
            bingingTotal:'绑定总数：',
            bingingSuccess:'绑定成功数：',
            getProgressFailed:'获取进度条相关数据失败',
            resetProgressFailed:'重置当前门店进度条数据失败'
        },
        addMemberTable:{
        	addMember:'添加成员',
        	findMember:'查找成员',
        	chooseMember:'选择成员',
        	noData:'暂无数据',
            add:'添 加'
        },
        sure:'确 定',
        member:'门店成员',
        hintMsg:{
            queryStoreFail:'没有查询到门店',
            queryAllStoreFail:'查询所有门店信息失败',
            queryUndistributedUser:'没有查询到未分配门店的用户',
            distributedMemberSuccess:'分配成员到门店成功',
            distributedMemberFail:'分配成员到门店失败',
            // missPara:'缺少请求参数',
            chooseMember:'请选择成员',
            queryMemberFail:'查询门店成员失败',
            queryStoreInfoFail:'获取门店信息失败',
            alreadyDistributed:'该成员已分配到门店'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/shop.js